import PaginationActions from '../../../ui/components/paginationActions'

import theme from '../base'

const pagination = {
  MuiTablePagination: {
    defaultProps: {
      SelectProps: { fullWidth: false },
      ActionsComponent: PaginationActions,
    },
    styleOverrides: {
      root: {
        color: theme.palette.neutral.main,
      },
      selectRoot: {
        marginRight: theme.spacing(3),
        '& .MuiSelect-root': {
          height: theme.spacing(4),
        },
      },
      displayedRows: {
        marginRight: theme.spacing(3),
      },
      caption: {
        marginRight: theme.spacing(2),
        color: theme.palette.neutral.main,

        '&:first-of-type': {
          marginRight: 10,
        },
      },
      toolbar: {
        minHeight: 'initial',
        paddingLeft: 0,
      },
    },
  },
}

export default pagination
